import { useNavigate } from "react-router-dom";
import { Row, ContentCard, Button, ResponsiveFlex } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { dollars } from "byzantine";
import filters from "byzantine/src/filters";
import { useRecipient } from "byzantine/src/dbbl/businessLogic/entities/recipients";
import { useIsInternationalWireDualApprovalRequired } from "byzantine/src/dbbl/businessLogic/entities/users/hooks";
import { useCreateInternationalWireForm } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";
import { PAYMENT_ACTIVITY_ROUTE } from "../../../PaymentActivity/routes";
import styles from "./InternationalWire.module.scss";

const ReceiptScreen = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const { getValues, reset } = useCreateInternationalWireForm();
  const { amount, recipientId, currencyTransferPreference, quote, id } =
    getValues();
  const isReceivePreference = currencyTransferPreference === "receive";
  const selectedRecipient = useRecipient(recipientId);
  const internationalWireDualApprovalRequired =
    useIsInternationalWireDualApprovalRequired();

  if (!selectedRecipient) return null;

  const { name } = selectedRecipient;

  const handleClickDone = () => {
    window.location.assign(`/${PAYMENT_ACTIVITY_ROUTE}/${id}`);
  };

  const handleClickCTA = () => {
    reset();
    navigate("/wires");
  };

  return (
    <div className={styles.receiptContainer}>
      <ContentCard>
        <div className={styles.cardContainer}>
          <h3 className="fontColor--heading">
            {internationalWireDualApprovalRequired
              ? l10n.getString("international-wire-submitted-for-approval")
              : l10n.getString("international-wire-submitted")}
            <i className="narmi-icon-check margin--left--xs" />
          </h3>
          <div className={styles.contentContainer}>
            <ResponsiveFlex gapSize="l">
              <Row>
                <Row.Item>
                  <p>{l10n.getString("label-to")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{name}</p>
                </Row.Item>
              </Row>
              <Row>
                <Row.Item>
                  <p>
                    {isReceivePreference && quote
                      ? l10n.getString("label-estimated-amount")
                      : l10n.getString("label-amount")}
                  </p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{`${filters.currency(
                    dollars(
                      isReceivePreference && quote
                        ? quote.converted_amount || "0"
                        : amount
                    ),
                    {
                      hasDecimal: true,
                    }
                  )}`}</p>
                </Row.Item>
              </Row>
              <Row>
                <Row.Item>
                  <p>{l10n.getString("label-delivery-speed")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{l10n.getString("international-wire-receipt-delivery")}</p>
                </Row.Item>
              </Row>
            </ResponsiveFlex>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              label={l10n.getString("label-done")}
              testId="international-wire-receipt-done"
              onClick={handleClickDone}
            />
            <Button
              kind="secondary"
              label={l10n.getString("international-wire-receipt-cta")}
              testId="international-wire-receipt-cta-button"
              onClick={handleClickCTA}
            />
          </div>
        </div>
      </ContentCard>
    </div>
  );
};

export default ReceiptScreen;
